import ChangeIssueTypeModalContent from './ChangeIssueTypeModalContent';
import {connect} from '../../app/connect';
import {
  getIssueAttributesDefinitionsEntitiesMap,
  getIssueAttributesMappingEntitiesMap,
  getIssueTypesAdminEntitiesMap
} from '../../app/selectors';

const mapStateToProps = state => ({
  issueTypeEntitiesMap: getIssueTypesAdminEntitiesMap(state),
  issueCustomAttributes: getIssueAttributesDefinitionsEntitiesMap(state),
  issueCustomAttributeMappings: getIssueAttributesMappingEntitiesMap(state)
});

export default connect(mapStateToProps)(ChangeIssueTypeModalContent);
